export default __webpack_public_path__ + "static/media/char_body_prem_001.973c7cf0.png";